import React, { Suspense, useCallback, useMemo, useState } from 'react'
import { goToCalculatorLink } from '@blocks/BlockInvestCalculator'
import { ANALITYCS_InvestorFordStartInvestingButtonIds } from '@constants/analitycs-ids'
import { PageSettings } from '@http/api-models/page-settings'
import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import type { SavingCalculatorProgramsResponse } from '@http/api-models/SavingPrograms'
import PageAnimation from '@shared/components/page-animation'
import { ExternalPaths } from '@shared/menu-items/paths'
import { isProduction } from '@shared/pipes/config'
import { getMarketingData } from '@shared/pipes/marketing-data'
import { yaCounter } from '@shared/pipes/ya-counter'
import dynamic from 'next/dynamic'
import type { SavingsParams } from 'ssr-resolvers/savings-params'

import { ModalSavings } from './ModalSavings/ModalSavings'
import { SectionAboutDeposit } from './SectionAboutDeposit'
import { SectionDeposit } from './SectionDeposit'
import { SectionInvestors } from './SectionInvestors'
import { SectionMain } from './SectionMain'
import { SectionMap } from './SectionMap'
import { SectionProtected } from './SectionProtected'
import { SectionStart } from './SectionStart'

const BlockInvestCalculator = dynamic(() =>
	import('@blocks/BlockInvestCalculator/index').then((data) => data.BlockInvestCalculator)
)

const getInvestorLkLink = () => {
	const marketingData = getMarketingData()
	const params = new URLSearchParams()

	if (marketingData?.qsParams) {
		Object.entries(marketingData.qsParams).forEach(([key, value]) => {
			params.set(key, String(value))
		})
	}

	const wcid = marketingData?.yandexClientId || ''
	if (wcid) {
		params.set('wcid', wcid)
	}
	if (marketingData?.entryUrl) {
		params.set('refLink', marketingData.entryUrl)
	}

	const baseUrl = isProduction ? ExternalPaths.investorLk : ExternalPaths.testInvestorLk
	const search = params.toString()

	return search ? `${baseUrl}?${search}` : baseUrl
}

export const openInvestorLkBlank = () => {
	window.open(getInvestorLkLink(), '_blank')
}

export interface InvestorsFondPageProps {
	pageSettings: PageSettings & {
		savings?: {
			params: SavingsParams
			programs: SavingCalculatorProgramsResponse
		}
		pledgeSummary?: PledgeSummaryResponse | undefined
	}
}

export const InvestorsFond = ({ pageSettings }: InvestorsFondPageProps) => {
	const [showModal, setShowModal] = useState(false)

	const onModalClose = useCallback(() => {
		setShowModal(false)
	}, [setShowModal])

	const { maxCashback, maxValue, minValue } = useMemo(() => {
		return (
			pageSettings?.savings?.params ||
			({
				maxCashback: '0',
				maxValue: '0',
				minValue: '0',
			})
		)
	}, [pageSettings])

	return (
		<PageAnimation>

			<ModalSavings showModal={showModal} onModalClose={onModalClose} />
			<SectionMain
				maxCashback={maxCashback}
				buttonProps={{
					id: ANALITYCS_InvestorFordStartInvestingButtonIds(0),
					onClick: goToCalculatorLink,
				}}
			/>
			{/* <SectionBanks /> */}
			{/* <InvestFuture /> */}
			<SectionDeposit />
			<SectionProtected />
			<SectionMap pledgeSummary={pageSettings.pledgeSummary} />
			<Suspense>
				<BlockInvestCalculator
					annualInterestRate={[minValue, maxValue]}
					onButtonClick={() => {
						yaCounter.utils.reachGoal('invest_download_presentation')
						openInvestorLkBlank()
					}}
				/>
			</Suspense>
			{/* <SectionHow maxCashback={maxCashback} maxValue={maxValue} minValue={minValue} /> */}
			{/* <SectionFeedback /> */}
			{/* <SectionOpen /> */}
			<SectionAboutDeposit />
			<SectionInvestors />
			{/* <SectionApps /> */}
			<SectionStart goToInvestorLk={openInvestorLkBlank} />
			{/* <SectionGift /> */}
			{/* <SectionConsultNew /> */}

			{/* <Faq accordionElements={investFaq} /> */}
		</PageAnimation>
	)
}
